import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  padding: var(--space-200) var(--space-300);
  text-align: left;
  white-space: wrap;
`;
export const Title = styled.div `
  color: var(--text-primary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`;
export const Content = styled.div `
  color: var(--text-secondary);
  // TODO: change font-family
  font-family: 'PT Mono', monospace;
  font-size: 12px;
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-200); /* 133.333% */
  letter-spacing: var(--font-letter-spacing-normal);
  width: 100%;
`;
